module.exports = {
    Answers: {
        NO_ANSWER: -1,
        NO_OPINION_ANSWER: -2,
        OTHER_ANSWER: -3,
        OTHER_ANSWER_WITH_TEXT: -4
    },
    Operators: {
        EXIST: 'exist',
        EQUAL: 'equal',
        NOT_EQUAL: 'notEqual',
        GT: 'gt',
        LT: 'lt',
        INCLUDES: 'includes',
        ANY: 'any',
        NOT_INCLUDES_ALL: 'notIncludesAll',
        NOT_INCLUDES_ANY: 'notIncludesAny',
        TRUE: 'true',
        ANSWERS_COUNT_GT: 'answersCountGt',
        ANSWERS_COUNT_LT: 'answersCountLt',
        ANSWERS_COUNT: 'answersCount'
    }
};
